import { Component } from '@angular/core';
import { CMSService } from '../Services/cms.service';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { CmsAboutUsTimelineProperties } from '../Models/CmsAboutUsProperties';
import * as $ from 'jquery';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-cms-aboutustimeline',
  templateUrl: './cms-aboutustimeline.component.html',
  styleUrls: ['./cms-aboutustimeline.component.css']
})
export class CmsAboutUsTimelineComponent {
  fSocialObj = new CmsAboutUsTimelineProperties();
  constructor(private userService: CMSService, public cmsService: CMSService, private http: HttpClient) { }
  baseUrl = environment.baseUrl;
  public progress: number;
  public message: string;
  public imagePath: any;
  public uploadFile = (files) => {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    this.http.post(this.baseUrl+'/CmsAboutUs/SaveAboutUsTimelineImages', formData, { reportProgress: true, observe: 'events' })
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          this.imagePath = event.body;
          this.message = 'Uploaded Successfully...';
          //this.onUploadFinished.emit(event.body);
        }
      });
  }
  ngOnInit() {
    this.LoadEditableData();
  }
  LoadEditableData() {
    try {
      if (localStorage.getItem("aboutUsID") != undefined || localStorage.getItem("aboutUsID") != null) {
        let id = Number(localStorage.getItem("aboutUsID"));
        if (id != 0 || id != undefined) {
          this.userService.getAboutUsTimelineById(id).subscribe((data) => {
            this.fSocialObj = data[0] as CmsAboutUsTimelineProperties;
            localStorage.removeItem("aboutUsID");
          });
        }
      }
    }
    catch (e) {
      //////console.log (e);
    }
  }
  onSubmit() {
    if (this.fSocialObj.timelineID == 0 || this.fSocialObj.timelineID == null) {
      this.fSocialObj.occasionImage = this.imagePath;
      this.userService.createAboutUsTimeline(this.fSocialObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data inserted Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    } else {
      this.fSocialObj.occasionImage = this.imagePath;
      this.userService.updateAboutUsTimeline(this.fSocialObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data updated Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while updating data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }

    ////////console.log (this.imagePath);
  }
  cancel() {
    this.fSocialObj = new CmsAboutUsTimelineProperties();
  }
}
